import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { useI18n } from '@/i18n/LanguageContext';

const CookieConsent: React.FC = () => {
  const { t, path } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('bb_cookie_choice')) setShow(true);
  }, []);

  const choose = (v: string) => {
    localStorage.setItem('bb_cookie_choice', v);
    setShow(false);
    // Let the floating action stack drop back down to its normal offset now
    // that this banner no longer occupies the bottom of the viewport.
    window.dispatchEvent(new CustomEvent('gg:cookie-choice'));
  };


  if (!show) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[120] mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-4 shadow-2xl sm:flex sm:items-center sm:gap-4">
      <Cookie className="hidden h-6 w-6 shrink-0 text-orange-500 sm:block" />
      <p className="flex-1 text-sm text-slate-600">
        {t('cookie.text')}{' '}
        <Link to={path('/privacy')} className="font-bold text-orange-600 underline">
          {t('footer.privacy')}
        </Link>
      </p>
      <div className="mt-3 flex gap-2 sm:mt-0">
        <button onClick={() => choose('declined')} className="flex-1 rounded-lg border border-slate-300 px-4 py-2 text-sm font-bold text-slate-700 hover:bg-slate-50">
          {t('cookie.decline')}
        </button>
        <button onClick={() => choose('accepted')} className="flex-1 rounded-lg bg-slate-900 px-4 py-2 text-sm font-bold text-white hover:bg-slate-800">
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
